import React, { useState } from 'react';
import { Grid, TextField, Button, Link, LinearProgress } from '@material-ui/core';
import { useForm } from 'react-hook-form';
import { Link as LinkRouter } from 'react-router-dom';
import { useDispatch } from "react-redux";
import AuthService from '../../../services/AuthService';
import { showSnackBar } from '../../../redux/actions/ui';
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: "5em",   
    [theme.breakpoints.down('sm')]: {
      marginTop: "0",
    },
  }
}));

function FortgotPassowrd() {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState();
  const dispatch = useDispatch();

  const { register, errors, handleSubmit } = useForm({
    validateCriteriaMode: "all",
    mode: "onChange"
  });

  const onSubmit = async data => {
    const {username} = data;    
    forgotPassword(username);    
  };

  const forgotPassword = async (email) => {
    setLoading(true);
    try{      
      await AuthService.forgotPassword(email);           
      setLoading(false);
      setSuccess("An email was sent");
    }catch (error) {
      dispatch(showSnackBar("An error occurred!", 'error'));        
      setLoading(false);
    }
  }

  return (
    <form noValidate autoComplete="off" onSubmit={handleSubmit(onSubmit)} className={classes.root}>                    
      <Grid item xs={12}>
        <h2 style={ {textAlign: "center"} }>Forgot password</h2>
        <TextField 
          name="username"
          label="your email"
          placeholder="email@example.com"
          variant="filled"
          fullWidth={true}

          inputRef={register({ required: true, pattern: {
            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
            message: "Invalid email address"
          }})}
          error={errors.username ? true : false}
          helperText={errors.username ? errors.username.message : null}
        />
      </Grid>
      <Grid item xs
      ={12} style={ {marginTop: "0.5em"} }>
        <Link 
          component={LinkRouter}
          to={'/auth/pre-check/'}
          > 
          Back to login
        </Link>
      </Grid>

      <Grid item xs={12} style={ {marginTop: "0.5em"} }>
        <div style={{position: "relative", width: "100%"}}> 
          {!loading && success && <h4 style={ {top: "-1em", position: "relative",  textAlign: "center"} }>{success}</h4>}           
        </div>
      </Grid>      

      <Grid item xs={12} style={ {marginTop: "3em"} }>
        {/* Loading */}
        {loading && <LinearProgress /> }

        <Button
          style={ { height: "3em", color: "white", textTransform: "none", fontSize: "1.3em", fontWeight: "bold"} }
          color="primary"
          disabled={loading}
          fullWidth={true}
          variant="contained"
          type="submit">
          Send recovery email
        </Button>                      
      </Grid>
    </form>
  )
}

export default FortgotPassowrd;